import theme from 'config/theme';

export default {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '50px',
    marginTop: '26px',
  },
  row: {
    display: 'flex',
    gap: '12px',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    flexDirection: 'column',

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  checkBoxWrapper: {
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '4px',
    border: `1px solid ${theme.palette.grays.gray200}`,
    padding: '12px',
    margin: 0,
    height: '40px',
    alignItems: 'center',
    'div:last-of-type': {
      width: 'auto',
      order: -1,
    },
  },
  title: {
    color: theme.palette.grays.gray700,
  },
  vehicleDetailsActions: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  fileWrapper: {
    height: '300px !important',
    minHeight: '300px !important',
  },
};
